webpackJsonp([98771256499994],{

/***/ 1024:
/***/ (function(module, exports, __webpack_require__) {

	var createCompounder = __webpack_require__(402);
	
	/**
	 * Converts `string` to
	 * [snake case](https://en.wikipedia.org/wiki/Snake_case).
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to convert.
	 * @returns {string} Returns the snake cased string.
	 * @example
	 *
	 * _.snakeCase('Foo Bar');
	 * // => 'foo_bar'
	 *
	 * _.snakeCase('fooBar');
	 * // => 'foo_bar'
	 *
	 * _.snakeCase('--FOO-BAR--');
	 * // => 'foo_bar'
	 */
	var snakeCase = createCompounder(function(result, word, index) {
	  return result + (index ? '_' : '') + word.toLowerCase();
	});
	
	module.exports = snakeCase;


/***/ }),

/***/ 496:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(66);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _kebabCase = __webpack_require__(186);
	
	var _kebabCase2 = _interopRequireDefault(_kebabCase);
	
	var _snakeCase = __webpack_require__(1024);
	
	var _snakeCase2 = _interopRequireDefault(_snakeCase);
	
	var _gatsbyLink = __webpack_require__(18);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Era = function (_React$Component) {
	  _inherits(Era, _React$Component);
	
	  function Era(props) {
	    _classCallCheck(this, Era);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      hovered: false
	    };
	
	    _this.handleMouseEnter = _this.handleMouseEnter.bind(_this);
	    _this.handleMouseLeave = _this.handleMouseLeave.bind(_this);
	    return _this;
	  }
	
	  Era.prototype.handleMouseEnter = function handleMouseEnter() {
	    this.setState({ hovered: true });
	  };
	
	  Era.prototype.handleMouseLeave = function handleMouseLeave() {
	    this.setState({ hovered: false });
	  };
	
	  Era.prototype.render = function render() {
	    var _props = this.props,
	        _props$era = _props.era,
	        fieldValue = _props$era.fieldValue,
	        totalCount = _props$era.totalCount,
	        data = _props.data;
	    var hovered = this.state.hovered;
	
	
	    var eraImageName = (0, _snakeCase2.default)(fieldValue).replace("_era", "");
	    var eraImage = data[eraImageName]; // eslint-disable-line security/detect-object-injection
	
	    var eraImagehover = data[eraImageName + "_hover"];
	
	    return _react2.default.createElement(
	      "div",
	      { className: "column is-one-third has-text-centered" },
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        {
	          onMouseEnter: this.handleMouseEnter,
	          onMouseLeave: this.handleMouseLeave,
	          to: "/tags/" + (0, _kebabCase2.default)(fieldValue) + "/"
	        },
	        _react2.default.createElement(
	          "figure",
	          { className: "image is-square" },
	          _react2.default.createElement(_gatsbyImage2.default, {
	            sizes: eraImage.childImageSharp.sizes,
	            className: hovered ? "era-hovered" : "",
	            outerWrapperClassName: "era-image-outer-wrapper"
	          }),
	          _react2.default.createElement(_gatsbyImage2.default, {
	            sizes: eraImagehover.childImageSharp.sizes,
	            outerWrapperClassName: "era-image-outer-wrapper-hover"
	          })
	        ),
	        _react2.default.createElement(
	          "p",
	          { className: "is-size-5" },
	          fieldValue.replace(/era/i, "")
	        ),
	        _react2.default.createElement(
	          "p",
	          { className: "subtitle is-6" },
	          "(" + totalCount + " videos)"
	        )
	      )
	    );
	  };
	
	  return Era;
	}(_react2.default.Component);
	
	exports.default = Era;
	module.exports = exports["default"];

/***/ }),

/***/ 497:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _era = __webpack_require__(496);
	
	var _era2 = _interopRequireDefault(_era);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Eras = function (_React$Component) {
	  _inherits(Eras, _React$Component);
	
	  function Eras() {
	    _classCallCheck(this, Eras);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Eras.prototype.render = function render() {
	    var _props = this.props,
	        eras = _props.eras,
	        data = _props.data;
	
	
	    return _react2.default.createElement(
	      "div",
	      { className: "columns is-centered" },
	      _react2.default.createElement(
	        "div",
	        { className: "column is-two-thirds" },
	        _react2.default.createElement(
	          "div",
	          { className: "columns is-multiline is-mobile" },
	          eras.map(function (era) {
	            return _react2.default.createElement(_era2.default, { era: era, key: era.fieldValue, data: data });
	          })
	        )
	      )
	    );
	  };
	
	  return Eras;
	}(_react2.default.Component);
	
	exports.default = Eras;
	module.exports = exports["default"];

/***/ }),

/***/ 516:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = exports.eraImage = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(15);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _HeaderImage = __webpack_require__(58);
	
	var _HeaderImage2 = _interopRequireDefault(_HeaderImage);
	
	var _Eras = __webpack_require__(497);
	
	var _Eras2 = _interopRequireDefault(_Eras);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VideosByErasPage = function VideosByErasPage(_ref) {
	  var data = _ref.data;
	  var group = data.allMarkdownRemark.group,
	      videosHeaderImage = data.videosHeaderImage;
	
	  // filter by era client side since apparently you can't filter
	  // graphql queries with substrings in arrays?
	
	  var EraTags = group.filter(function (x) {
	    return x.fieldValue.toLowerCase().includes("era");
	  });
	
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(_reactHelmet2.default, { title: "Videos By Era" }),
	    _react2.default.createElement(_HeaderImage2.default, { headerImage: videosHeaderImage }),
	    _react2.default.createElement(
	      "div",
	      { className: "section" },
	      _react2.default.createElement(
	        "div",
	        { className: "container", style: { paddingTop: "100px" } },
	        _react2.default.createElement(
	          "h1",
	          { className: "title is-1" },
	          "Videos By Era"
	        ),
	        _react2.default.createElement(_Eras2.default, { eras: EraTags, data: data })
	      )
	    )
	  );
	};
	
	exports.default = VideosByErasPage;
	
	/* eslint no-undef: "off" */
	
	var eraImage = exports.eraImage = "** extracted graphql fragment **";
	
	/* eslint no-undef: "off" */
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-videos-by-era-jsx-ba86c5d8ec95ec63b7fc.js